/*
 * Returns the full series and trim of a vehicle.
 */
export function vehicleToSeriesTrimFull(record: {
	series?: string;
	trim?: string;
}): string {
	// Check
	if (!record) {
		return '';
	}

	return `${record.series ? record.series + ' ' : ''}${record.trim ? record.trim : ''}`;
}
